export default __webpack_public_path__ + "static/istqb-platinum-cebe83737742ba9167813ed0787a1337.png";